import SContentWrapper from "src/components/contentwrapper/ContentWrapper";
import withWatchlist from "src/components/filmwebid/withWatchlist";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import SearchContentItem from "src/components/search/SearchContentItem";
import theme from "src/components/themes/DefaultTheme";
import { WatchableContent } from "src/lib/movieinfo/movieinfotypes";
import styled from 'src/lib/styles/css';
import { ISearchResult } from "src/lib/types/search";

//#region [Props]
type SearchContentListProps = {
    itemClickTracker: (id: string | number, title: string) => void;
    forceStreaming?: boolean;
    isSearching: boolean;
    contentList?: ISearchResult[] | WatchableContent[] | null;
    azShowScore?: boolean;
    azureSearchEnabled?: boolean;
};
//#endregion

//#region [Component]
export default function SearchContentList({ contentList, itemClickTracker, forceStreaming = false, isSearching, azShowScore = false, azureSearchEnabled = false }: SearchContentListProps) {
    return <SSearchContentList as="section">
        <SSectionTitle>Søkeresultat</SSectionTitle>
        {isSearching && <LoadingIndicator position="InlineCenter" label="Henter søkeresultat" size="large" />}
        {!isSearching && contentList && <SContentContainer>
            {contentList.length === 0 && <SNoHits>Ingen treff</SNoHits>}
            {contentList.map(item => {
                const anyItem = item as any;
                const key: string = `${anyItem.movieId}_${anyItem.streamingContentId}_${anyItem.document?.edi}_anyItem.document?.streamingId`;
                return <WLSearchContentItem key={key}
                    content={item}
                    clickTracker={itemClickTracker}
                    forceStreaming={forceStreaming}
                    wlcClassName="contentItem"
                    azShowScore={azShowScore}
                    azureSearchEnabled={azureSearchEnabled}
                />;
            })}
        </SContentContainer>}
    </SSearchContentList>;
}
//#endregion

const WLSearchContentItem = withWatchlist(SearchContentItem, "content");

//#region [Styles]
const SSearchContentList = styled(SContentWrapper)`
	color: var(--textcolor);
	margin-bottom: 30px;
	min-height: 90vh;
`;

const SSectionTitle = styled.h1`
	text-align: center;
	margin: 1rem;
`;

const SContentContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;



	.contentItem {
		flex: 0 0 auto;
		width: calc((100% - (20px * 2)) / 3);

		@media ${theme.mq.desktop} {
			width: calc((100% - (20px * 5)) / 6);
		}
	}
`;

const SNoHits = styled.p`
	text-align: center;
	margin: 1rem;
`;


//#endregion